export interface SignupDetails {
  firstName: string;
  lastName: string;
  birthdate: string;
}

export interface SignupInput extends SignupDetails {
  email: string;
  password: string;
}

const isRealDate = (value: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  const parsed = new Date(Date.UTC(year, month - 1, day));
  return parsed.getUTCFullYear() === year && parsed.getUTCMonth() === month - 1 && parsed.getUTCDate() === day;
};

export const validateSignupDetails = (details: SignupDetails, now = new Date()): string | null => {
  if (!details.firstName.trim()) return "Enter your first name.";
  if (!details.lastName.trim()) return "Enter your last name.";
  if (!isRealDate(details.birthdate)) return "Enter a valid date of birth.";
  const [year, month, day] = details.birthdate.split("-").map(Number);
  const birthdate = new Date(Date.UTC(year, month - 1, day));
  const eligibilityDate = new Date(Date.UTC(now.getUTCFullYear() - 13, now.getUTCMonth(), now.getUTCDate()));
  return birthdate > eligibilityDate ? "You must be at least 13 years old to create an account." : null;
};

export const buildSignUpInput = (input: SignupInput) => {
  const email = input.email.trim().toLowerCase();
  return {
    username: email,
    password: input.password,
    options: {
      userAttributes: {
        email,
        given_name: input.firstName.trim().replace(/\s+/g, " "),
        family_name: input.lastName.trim().replace(/\s+/g, " "),
        birthdate: input.birthdate,
      },
    },
  };
};
